module.exports = __webpack_public_path__ + "static/media/kayak.56dce981.svg";